import React, { createContext, useContext, useEffect, useState } from "react";
import { dict } from "@/lib/i18n";

const LanguageContext = createContext({
  lang: "ar",
  setLang: () => {},
  t: (k) => k,
  dir: "rtl",
});

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    return localStorage.getItem("zabatna_lang") || "ar";
  });

  useEffect(() => {
    const dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);
    document.documentElement.setAttribute("lang", lang);
    localStorage.setItem("zabatna_lang", lang);
  }, [lang]);

  const setLang = (l) => setLangState(l);
  const toggle = () => setLangState((l) => (l === "ar" ? "en" : "ar"));

  const tr = (key) => (dict[lang] && dict[lang][key]) || dict.ar[key] || key;

  return (
    <LanguageContext.Provider
      value={{ lang, setLang, toggle, t: tr, dir: lang === "ar" ? "rtl" : "ltr" }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
